
export const statusData = [
  { name: "En attente de mise en service", id: "waiting", color: "#E3A322" },
  { name: "En service", id: "operating", color: "#91C73C" },
  { name: "Hors service", id: "off", color: "#849191" },
];

export const motorData = [
  { name: "Essence", id: "essence", color:"url(#colorGreen)"},
  { name: "Hybride essence", id: "hybrideessence", color:"url(#colorGrey)"},
  { name: "Hybride rechargeable essence", id: "hybriderecessence", color:"url(#colorGrey)"},
  { name: "Diesel", id: "diesel", color:"url(#colorOrange)"},
  { name: "Hybride diesel", id: "hybridediesel", color:"url(#colorGrey)" },
  { name: "Hybride rechargeable diesel", id: "hybriderecdiesel", color:"url(#colorGrey)"},
  { name: "Electrique", id: "electrique", color:"url(#colorBlue)" },
  { name: "Hydrogène", id: "hydrogene", color:"url(#colorPurple)" },
  { name: "Biogaz", id: "biogaz" , color:"url(#colorYellow)"},
];

export const energyData = [
  { name: "SP95", id: "SP95", color:"url(#colorGreen)"},
  { name: "SP98", id: "SP98", color:"url(#colorGreen)"},
  { name: "Diesel", id: "diesel", color:"url(#colorOrange)"},
  { name: "Hydrogène", id: "hydrogen", color:"url(#colorPurple)"},
  { name: "Biogaz", id: "biogas" , color:"url(#colorYellow)"},
  { name: "Electricité", id: "electricity", color:"url(#colorBlue)"},
  { name: "Ethanol", id: "ethanol", color:"url(#colorRed)" },
];